"use client";

import React from "react";

export function Header62() {
  return (
    /* bg-wood-brown = hnědá, text-white = bílá */
    <section className="bg-wood-brown text-white font-sans px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container mx-auto max-w-lg text-center">
        <p className="mb-3 font-semibold md:mb-4 uppercase tracking-wider opacity-80">
          Galerie
        </p>
        
        {/* Nadpis - font Gelasio */}
        <h1 className="mb-5 text-[40px] font-bold font-serif leading-[1.1] md:mb-6 md:text-[56px] lg:text-[64px]">
          Naše práce
        </h1>
        
        <p className="text-base md:text-lg leading-[1.6] opacity-90">
        Projekty, kterým jsme vdechli nový život. Od základů roubenek až po jemnou truhlářskou práci.
        </p>

        <div className="mt-8 flex items-center justify-center gap-x-4 md:mt-10">
          <a 
            href="tel:+420723856780"
            className="px-8 py-3 bg-white text-wood-brown font-bold rounded-full hover:bg-opacity-90 transition-all inline-block text-center"
          >
            VOLAT
          </a>
          <a 
            href="/contact"
            className="px-8 py-3 border border-white text-white font-bold rounded-full hover:bg-white/10 transition-all inline-block text-center"
          >
            jiri@tesarstvi-sindelar.cz
          </a>
        </div>
      </div>
    </section>
  );
}